import { render, staticRenderFns } from "./InvestigatorForms.vue?vue&type=template&id=64809aa9&scoped=true"
import script from "./InvestigatorForms.vue?vue&type=script&lang=js"
export * from "./InvestigatorForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64809aa9",
  null
  
)

export default component.exports